import ConnectedFeaturedOffersModule from './ConnectedFeaturedOffersModule';

export default ConnectedFeaturedOffersModule;
